export const TYPES = {
  NONE: undefined,
  INITIAL: 'initial',
  OVERDUE: 'overdue',
} as const
